/* eslint-disable react/jsx-pascal-case */
import { ArrowCircleRight, FileDownload, Print } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { MaterialReactTable, MRT_ShowHideColumnsButton, MRT_ToggleDensePaddingButton, MRT_ToggleFullScreenButton } from 'material-react-table'
import { Link } from 'react-router-dom'
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const ServerSide = ({
    loading,
    data = [],
    columns,
    rowCount = 10,
    baseUrl,
    pagination,
    setPagination,
    // globalFilter,
    // setGlobalFilter,
    sorting,
    setSorting,
    columnFilter,
    setColumnFilter,
    columnVisibility
}) => {

    const exportToExcel = () => {
        let exportDataArr = [];
        data.forEach((dt) => {
            let exportData = Object.assign({}, dt);
            exportData.nama_pd = dt.opd.nama_pd
            exportData.namaDesa = dt.dataDesa === null ? '' : dt.dataDesa.nama_desa
            exportData.namaKec = dt.dataKecamatan === null ? '' : dt.dataKecamatan.nama_kec
            delete exportData.opd
            delete exportData.path
            console.log(dt);
            exportDataArr.push(exportData)
        })

        const worksheet = XLSX.utils.json_to_sheet(exportDataArr);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Export.xlsx`);
    };

    return (
        <MaterialReactTable
            columns={columns}
            data={data}
            muiTableHeadCellProps={{
                sx: {
                    fontSize: '0.875rem !important',
                    color: 'text.main !important'
                }
            }}
            muiTableFooterCellProps={{
                sx: {
                    fontSize: '0.875rem !important',
                    color: 'text.main !important'
                }
            }}
            muiTopToolbarProps={{
                sx: { fontSize: '0.875rem' }
            }}
            initialState={{
                columnVisibility: columnVisibility,
                showGlobalFilter: false
            }}
            enablePagination={true}
            manualPagination={true}
            muiPaginationProps={{
                rowsPerPageOptions: [10, 20, 50, 100]
            }}
            onPaginationChange={setPagination}
            rowCount={rowCount}

            manualFiltering={true} //turn off client-side filtering
            // onGlobalFilterChange={setGlobalFilter}
            onColumnFiltersChange={setColumnFilter}

            enableSorting={true}
            manualSorting={true}
            onSortingChange={setSorting}

            // enableColumnFilters={false}
            renderToolbarInternalActions={({ table }) => (
                <>
                    {/* <MRT_ToggleGlobalFilterButton table={table} color='text' /> */}
                    <MRT_ShowHideColumnsButton table={table} color='text' />
                    <MRT_ToggleFullScreenButton table={table} color='text' />
                    <MRT_ToggleDensePaddingButton table={table} color='text' />
                    <Tooltip title="Print">
                        <IconButton onClick={() => window.print()}>
                            <Print />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Export">
                        <IconButton onClick={() => exportToExcel()}>
                            <FileDownload />
                        </IconButton>
                    </Tooltip>
                </>
            )}
            state={{
                isLoading: loading,
                showColumnFilters: true,
                pagination: {
                    pageSize: pagination.pageSize,
                    pageIndex: pagination.pageIndex
                },
                // globalFilter,
                sorting,
                columnFilter
            }}
            enableRowActions={true}
            positionActionsColumn='first'
            renderRowActions={({ row, table }) => (
                <Tooltip title="Detail">
                    <IconButton
                        id="basic-button"
                        color='primary'
                        component={Link}
                        to={baseUrl + '/komponen'}
                        state={row.original.id}
                    >
                        <ArrowCircleRight fontSize='small' />
                    </IconButton>
                </Tooltip>
            )}
            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: 'Aksi', //change header text
                    size: 50, //make actions column wider
                    alignment: 'left'
                },

            }}
            muiFilterTextFieldProps={{
                sx: { width: '100%', paddingLeft: '0rem !important' },
                variant: 'outlined',
            }}
        />
    )
}

export default ServerSide